App.controller('SetPasswordCtrl', SetPasswordCtrl);

SetPasswordCtrl.$inject = [
    '$location',
    '$routeParams',
    'DispatcherService',
    'DialogService'
];

function SetPasswordCtrl($location, $routeParams, DispatcherService, DialogService) {
    var vm = this;

    vm.email = '';
    vm.password = '';
    vm.password_confirmation = '';

    vm.submit = submit;

    function submit() {
        DispatcherService.put('password', {
            email: vm.email,
            password: vm.password,
            password_confirmation: vm.password_confirmation,
            token: $routeParams.token
        }).then(function() {
            DialogService.success('Your password has been successfully updated');

            $location.path('/login');
        });
    }
}